import { useMutation } from "react-query";
import { addSingleAlarm } from "../../../../actions/CarrierAgreementMgmt/Security";

const useAddSingleAlarm = () => {
  return useMutation(addSingleAlarm);
};
export default useAddSingleAlarm;
